// extracted by mini-css-extract-plugin
export default {"no-message__box":"MessageNoStories_no-message__box__4jcZi","no-message__text":"MessageNoStories_no-message__text__PzvWS","no-message__btn":"MessageNoStories_no-message__btn__eVSUW"};